<template>
  <div class="accessory_cost_detail_dialog">
    <custom-dialog :visible="visible" width="1200px" :title="model.title" v-on="$listeners">
      <div class="dialog-body">
        <h1 class="item-title">{{ $t('crm_accessoryCost_detail_dialog.ye_wu_xin_xi') }}</h1>
        <div class="item-title-info">
          <el-row>
            <el-col :span="4">
              <span class="label">{{ $t('crm_accessoryCost_detail_dialog.ding_dan_hao') }}</span>
              <span class="value">{{ info.orderGoodsCode || '-' }}</span>
            </el-col>
            <el-col :span="4">
              <span class="label">{{ $t('crm_accessoryCost_detail_dialog.chan_pin_xing_hao') }}:</span>
              <span class="value">{{ info.productCode || '-' }}</span>
            </el-col>
            <el-col :span="4">
              <span class="label">{{ $t('crm_accessoryCost_detail_dialog.ji_shen_hao') }}:</span>
              <span class="value">{{ info.bodyNum || '-' }}</span>
            </el-col>

            <el-col :span="4">
              <span class="label">{{ $t('crm_accessoryCost_detail_dialog.pei_jian_shu_liang') }}:</span>
              <span class="value">{{ info.bookingNum || '-' }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">{{ $t('crm_accessoryCost_detail_dialog.shou_hou_gong_si') }}:</span>
              <span class="value">{{ info.afterServiceName || '-' }}</span>
            </el-col>
          </el-row>
        </div>
        <h1 class="item-title">{{ $t('crm_accessoryCost_detail_dialog.fen_tan_xiang_qing') }}</h1>
        <div class="table-dialog-bd">
          <custom-table :column="tableColumnMonth" height="500px" :data="tableList" :index="true" :slots="['partSn','billTermNum',...shareYearMonth]">
            <template v-slot:partSn="scope">
              <span>
                {{ scope.row.goodsCode || '-'}}/{{ scope.row.goodsName|| '-'}}
              </span>
            </template>
            <template v-slot:billTermNum="scope">
          <span>
            {{ scope.row.billTermNum || '-'}}/{{ scope.row.billTotalTerm|| '-'}}
          </span>
        </template>
            <template v-for="item in shareYearMonth" :slot="item" slot-scope="scope">
          {{ scope.row.monthListObj[item] }}
        </template>
          </custom-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  components: {

  },
  computed: {
    shareYearMonth() {
      const allMonths = [];
      if (this.tableList.length && this.tableList[0].monthList.length) {
        // 遍历monthList数组
        this.tableList[0].monthList.forEach(month => {
          // 将新对象添加到arr数组中
          allMonths.push(month.revenueMonth);
        });

      }
      return allMonths;
    },
    tableColumnMonth() {
      let allColumn = this.tableColumn;
      if (this.shareYearMonth && this.shareYearMonth.length) {
        const shareYearMonth = this.shareYearMonth.map(item => ({
          columnName: item,
          columnCode: item,
          selected: true
        }));
        allColumn = [...this.tableColumn, ...shareYearMonth];
      }
      return allColumn;
    }
  },
  data() {
    return {
      tableCode: 'accessory_cost_detail',
      info: {},
      orderGiveawayId: '',
      tableList: [],
      totalRows: null,
    };
  },
  mounted() {
    this.initDialog();
    this.getTableColumn();

  },

  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      if (this.model.type === 'detail') {
        this.orderGiveawayId = this.model.data.orderGiveawayId;
        // this.orderGiveawayId = '988171266206339072';
        // this.bodyNum = '20200509006';
        this.getTableList();
      }
    },
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(`${apis.giveawayCostshareDetail}/${this.orderGiveawayId}`).then((res) => {
        this.info = res.data.orderPartCostViewBo || [];
        res.data.orderPartRevenueBoList.forEach(orderPart => {
          // 遍历orderPart的monthList数组
          orderPart.monthListObj = {};
          orderPart.monthList.forEach(month => {
            // 将revenueMonth作为key，costPrice作为val存储到monthListObj中
            // 如果key已经存在，你可能需要决定是覆盖还是累加值（这里以覆盖为例）
            orderPart.monthListObj[`${month.revenueMonth}`] = month.costPrice;
          });
        });
        // console.log(res.data.orderPartRevenueBoList);
        this.tableList = res.data.orderPartRevenueBoList || [];

      });
    },


    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },

  },
};
</script>

<style lang="scss">
.accessory_cost_detail_dialog {
  .part-box {
    padding-bottom: 16px;
    display: flex;
    flex-flow: row wrap;
    .part-item {
      width: 208px;
      height: 100px;
      background: #f8f9fb;
      border-radius: 2px;
       border: 1px solid #f2f3fb;
      padding: 2px 14px 8px;
      margin: 10px 10px 0 0;
      .part-content {
        display: flex;
        .title {
          .key {
            font-size: 12px;
            font-weight: bold;
            color: #495057;
            line-height: 36px;
          }
          .val {
            height: 32px;
            font-size: 20px;
            color: #394668;
            line-height: 32px;
            margin-top: -7px;
          }
        }
        i {
          margin-left: auto;
          font-size: 40px;
          &.error {
            color: #ff5c5b;
          }
          &.warning {
            color: #f9c851;
          }
        }
      }
      .process {
        position: relative;
        height: 3px;
        width: 100%;
        background: #f0f2f5;
        border-radius: 2px;
        overflow: hidden;
        margin: 6px 0 8px;
        .process-bar {
          position: absolute;
          height: 100%;
          background: #0d9ae0;
          border-radius: 1px;
        }
        .caveat-val {
          background: #0d9ae0 !important;
        }
        .warn-val {
          background: #f36704 !important;
        }
        .beyond-val {
          background-color: #ff0100 !important;
        }
      }

      .life {
        height: 20px;
        font-size: 12px;
        color: #98a6ad;
        line-height: 20px;
      }


      &.warning {
        .process-bar {
          // background: #f36704 !important;
        }
        .critical-val {
          background: #f36704;
        }
        .beyond-val {
          background-color: #ff0100 !important;
        }
      }


        &:hover {
          // cursor: pointer;
          border-color: rgba(13, 154, 224, 0.3);
          background-color: #fff;
        }
        .component-name {
          $h: 18px;
          height: $h;
          line-height: $h;
          font-size: 12px;
          font-weight: bold;
          color: #495057;
        }
        // .using-time {
        //   $h: 24px;
        //   color: #394668;
        //   font-weight: bold;
        //   font-size: 20px;
        //   line-height: $h;
        //   height: $h;
        // }
        .process-content {
          overflow: hidden;
          position: relative;
          padding-bottom: 2px;
        }
        .process {
          position: relative;
          height: 2px;
          width: 100%;
          background: #f0f2f5;
          border-radius: 1px;
          overflow: hidden;
          margin-top: 4px;
          .process-bar {
            position: absolute;
            height: 100%;
            background: #0d9ae0;
            border-radius: 1px;
          }
          .caveat-val {
            background: #0d9ae0 !important;
          }
          .warn-val {
            background: #f36704 !important;
          }
          .beyond-val {
            background-color: #ff0100 !important;
          }
        }
        .critical-val {
          width: 2px;
          height: 4px;
          position: absolute;
          top: 3px;
          background: #f36704;
          transform: translateX(-1px);
        }
        .beyond-val {
          background-color: #ff0100 !important;
        }
        .service-life {
          color: #98a6ad;
          font-size: 12px;
          line-height: 20px;
          margin-top: 8px;
          float: left;
        }
        &:hover {
          .detail {
            opacity: 1;
          }
        }
        .detail {
          color: #35b8e0;
          font-size: 12px;
          float: right;
          line-height: 20px;
          position: absolute;
          right: 14px;
          bottom: 8px;
          opacity: 0;
          transition: all 0.3s;
          &:hover {
            cursor: pointer;
          }
        }
        .icon-content {
          width: 24px;
          height: 24px;
          position: absolute;
          right: 10px;
          top: 10px;
          .icon {
            font-size: 24px;
          }

          > img {
            max-width: 100%;
            max-height: 100%;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            position: absolute;
            margin: auto;
          }
        }

        .device-status {
          color: #6c757d;
          font-size: 12px;
          margin-top: 12px;
          line-height: 18px;
        }
        .device-time {
          color: #98a6ad;
          line-height: 12px;
          height: 12px;
          margin-top: 10px;
          font-size: 12px;
        }
        .date {
          color: #98a6ad;
          font-size: 12px;
          margin-top: 16px;
        }

    }
  }
  .part-pic {
    padding: 16px;
    h1 {
      font-weight: bold;
      line-height: 17px;
      margin-bottom: 10px;

      font-size: 12px;
      color: #495057;
      line-height: 17px;
    }
    ul li img {
      width: 60px;
      height: 60px;
      border-radius: 2px;
      // border: 1px solid rgba(238, 238, 238, 1);
      margin-right: 16px;
    }
  }
}
</style>
